import { render } from "./VxList.vue?vue&type=template&id=8a33596c"
import script from "./VxList.vue?vue&type=script&lang=js"
export * from "./VxList.vue?vue&type=script&lang=js"

import "./VxList.vue?vue&type=style&index=0&id=8a33596c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__